import $ from 'zepto';
import { onDocumentReady } from '../../main';
import { parseJSON, log } from '../../utils';
import { formRowItemConfigSelector } from '../../utils/constants/classes';

const config = {};

/**
 *
 * @typedef {object} Validation
 * @property {string} name
 * @property {string|boolean} [message]
 * @property {Function} [test]
 */

/**
 *
 * @typedef {object} RowConfig
 * @property {Validation[]} validations
 */

/**
 * @return {RowConfig}
 */
const createEmptyConfig = () => ({
  validations: [],
});

/**
 *
 * @param {Validation} validation
 */
const checkValidation = (validation) => {
  if (validation.message === undefined) {
    log.warn('Validation message not provided, if this is intentionally please set message as false');
  }

  if (!validation.name && !validation.test) {
    log.warn('Missing name or test for validation, please add one of the two');
  }
};

/**
 *
 * @param {Validation[]} oldvalidations
 * @param {Validation[]} newValidations
 * @return {Validation[]}
 */
const mergeValidations = (oldvalidations, newValidations) => {
  const validations = [].concat(newValidations);

  validations.forEach(checkValidation);

  return oldvalidations.concat(newValidations);
};

/**
 *
 * @param {RowConfig} oldConfig
 * @param {RowConfig} newConfig
 * @param RowConfig
 */
const extendConfig = (oldConfig, newConfig) => {
  const validations = mergeValidations(oldConfig.validations, newConfig.validations);

  return Object.assign(oldConfig, newConfig, { validations });
};

/**
 *
 * @param {string} id
 * @return {RowConfig}
 */
const getRowItemConfig = (id) => {
  if (config[id]) {
    return config[id];
  }

  config[id] = createEmptyConfig();

  return config[id];
};

/**
 *
 * @param {{Object.<string, RowConfig>}} itemsConfig
 */
const addRowItemsConfig = (itemsConfig) => {
  Object.keys(itemsConfig).forEach((id) => {
    const newConfig = itemsConfig[id];

    const oldConfig = getRowItemConfig(id);

    config[id] = extendConfig(oldConfig, newConfig);
  });
};

const searchForRowItemsConfig = () => {
  $(formRowItemConfigSelector).each((index, item) => {
    const $formRowItemConfig = $(item);

    const newConfig = parseJSON($formRowItemConfig.html());
    addRowItemsConfig(newConfig);

    $formRowItemConfig.remove();
  });
};
/**
 *
 * @param {string} id
 * @param {string|string[]} validation
 */
const removeRowItemValidations = (id, validation) => {
  const itemConfig = getRowItemConfig(id);
  const { validations } = itemConfig;
  const validationsToRemove = [].concat(validation);

  itemConfig.validations = validations.filter((item) => validationsToRemove.indexOf(item.name) === -1);
};

export {
  removeRowItemValidations,
  searchForRowItemsConfig,
  addRowItemsConfig,
  getRowItemConfig,
  config,
};

onDocumentReady('FormItemConfig', () => {
  searchForRowItemsConfig();
});
